import axios from "axios"
import { port } from "../CommonComponents/CommonWorkers";

console.log(process.env.NODE_ENV)
const address = window.location.protocol + "//" + window.location.hostname + port + "/api"

export const getList = async () =>{
    const list = (await axios.get(`${address}/helix/getList`)).data;
    return list;
}

export const getTests = async (sortingField = undefined) =>{
    const tests = (await axios.get(`${address}/helix/getTests`, {params: {sortingField: sortingField}})).data;
    return tests;
}

export const getPivotTable = async () =>{
    const list = (await axios.get(`${address}/helix/getPivotTable`)).data;
    return list;
}

export const editRow = async (data) =>{
    const id = (await axios.post(`${address}/helix/editRow`,
    {
        id: data.ID,
        orderCode: data.diaryId,
        orderDate: data.ORDER_DATE,
        testName: data.TEST_NAME,
        numEntry: data.NUMERIC_ENTRY,
        refLow: data.REFERENCE_LO,
        refHi: data.REFERENCE_HI,
        units: data.UNITS,
    })).data;
    return id;
}

export const deleteRow = async (id) => {
    const res = (await axios.post(`${address}/helix/deleteRow`, {id: id})).data;
    return res;
}
 